import PurchaseCard from 'Components/UserManagement/ViewUser/PurchaseHistory';
import './styles.scss';
//core
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

//redux
import { useDispatch } from 'react-redux';
import { fetchUserPurchaseHistory } from '../../../../../Redux/Slices/userManagementSlice';

function PurchaseHistory() { 
     
    const {id} = useParams();
    const dispatch = useDispatch();
    
    const [purchaseHistoryData, setPurchaseHistoryData] = useState([])

   useEffect(()=>{
    dispatch(
        fetchUserPurchaseHistory({
            data:{id},
            callBack: getDataCB
        })
    )
   },[])

   const getDataCB = (value) => {
    console.log(value.data);
    setPurchaseHistoryData(value.data)
   }

    return (
        <div className="user-profile-details-purchase">
            <div className="view-user-container-header">
                <h2>Purchase History</h2>
            </div>

            <hr style={{ backgroundColor: "#E6E6E6" }} />

            <div className='view-user-purchase-container'>
                {purchaseHistoryData.length > 0 ? purchaseHistoryData.map((purchaseHistory, index) => (
                    <PurchaseCard 
                    key={index}
                    title={purchaseHistory?.product_name || "-"}
                    // kit_code={purchaseHistory?.kit_code || "-"}
                    pr_code={purchaseHistory?.purchase_request_id || "-"}
                    purchase_quantity={purchaseHistory?.quantity || "-"}
                    notes={purchaseHistory?.message || "-"}
                    />
                )): "No Data"}
            </div>
        </div>
    );
}

export default PurchaseHistory;
